// import React from 'react'
// import TabComponent from '../TabComponent'
// import { useDispatch } from 'react-redux';
// import { setHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
// import { IoMdTime } from 'react-icons/io';
// import { FaRegCheckCircle } from 'react-icons/fa';
// import TotalPendingRegisration from './TotalPendingRegisration';
// import TotalApprovedRegistration from './TotalApprovedRegistration';

// const TotalRegistrationTabComponent = () => {
//     const dispatch = useDispatch();

//     React.useEffect(() => {
//         dispatch(setHeaderName("Total Registration"));
//     }, []);

//     const tabsHeadData = [
//         { label: 'Pending', icon: <IoMdTime /> },
//         { label: 'Approved', icon: <FaRegCheckCircle /> },
//     ];
//     const tabsComponent = [<TotalPendingRegisration />, <TotalApprovedRegistration />]

//     return (
//         <div>
//             <TabComponent />
//         </div>
//     )
// }

// export default TotalRegistrationTabComponent

import React from 'react';
import { useDispatch } from 'react-redux';
// import { setHeaderName } from '../../../../ReduxStore/Slices/headerSlice';

// import TabComponent from '../TabComponent';

import UserReferalsSheme from './UserReferalsSheme';
import FinancialConsultantReferalsScheme from './FinancialConsultantReferalsScheme';
import OperatorReferralsScheme from './OperatorReferralsScheme';
import TabComponent from '../../Operator/OperatorDashboard/TabComponent';
import { setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';

const ReferralsSchemeTabs = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setSubHeaderName("Referrals Scheme"));
    }, [dispatch]);

    const tabsHeadData = [
        { label: 'Referrals Tier', icon: "" },
        // { label: 'Financial Consultant', icon: '' },
        // { label: 'Operator', icon: '' },
        
    ];

    const tabsComponent = [
        <UserReferalsSheme />,
        // <FinancialConsultantReferalsScheme />,
        // <OperatorReferralsScheme />,
        
    ];

    return (
        <div>
            <TabComponent tabsData={tabsHeadData} tabComponents={tabsComponent} />
        </div>
    );
};

export default ReferralsSchemeTabs;
